import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Values } from "./components/values";
// import { Gallery } from "./components/gallery";
import { Partners } from "./components/patners";
import { Testimonials } from "./components/testimonials";
import { Team } from "./components/Team";
import { Contact } from "./components/contact";
import { Careers} from "./components/careers";
import { AboutUsPage } from "./components/about_us_page";
import { JobDetails } from "./components/jobDetails";
import { Footer } from "./components/footer";
import { BackupRecoveryPage } from "./components/backup_disaster_recovery";
import { NetworkInfrastructurePage } from "./components/network_infrastrucute";
import { DataCenterSolutionsPage } from "./components/data_center_page";
import { VirtualMachinesPage } from "./components/virtual_machines_page";
import { KubernetesSetupPage } from "./components/kubernetes_page";
import { DockerWebAppsPage } from "./components/docker_web_apps_page";
import { CCTVPage } from "./components/cctv_page";
import { BiometricsPage } from "./components/biometrics_page";
import { EndUserDevicesPage } from "./components/end_user_devices_page";
import { ERPSolutionsPage } from "./components/erp_solutions_page";
import { CRMSolutionsPage } from "./components/crm_page";
import { MobileApplicationsPage } from "./components/mobile_application_solutions";
import { WebPortalsPage } from "./components/web_portals_page";
import { IntegrationsPage } from "./components/integration_solutions_page";
import { EDMSPage } from "./components/edms_solutions_page";
import { USSDAndSmsPage } from "./components/sms_chatbot_ussd";
import { AnalyticsAndReportingPage } from "./components/analytics_reporting";
import { CloudNetworkDesignPage } from "./components/cloud_network_solutions";
import { CloudInfrastructureAuditPage } from "./components/cloud_infrastructure_audit_page";
import { CloudOptimizationPage } from "./components/cloud_optimization_page";
import { CloudDeploymentsPage } from "./components/cloud_deployments_page";
import { UnifiedCommunicationsPage } from "./components/unified_communications_page";
import { MobilityPage } from "./components/mobility_page";
import { ManagedItPage } from "./components/managed_it_page";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <Router>
      <main>
        <Navigation />
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Header data={landingPageData.Header} />
                  <Services data={landingPageData.Services} />
                  {/* <Features data={landingPageData.Features} /> */}
                  <About data={landingPageData.About} />
                  {/* <Gallery data={landingPageData.Gallery} /> */}
                  <Values data={landingPageData.Values} />
                  <Partners data={landingPageData.Partners} />
                  <Testimonials data={landingPageData.Testimonials} />
                  {/* <Team data={landingPageData.Team} /> */}
                  
                </>
              }
            />
            <Route
              path="/careers"
              element={
                <>
                  <Careers data={landingPageData.Careers} />
                </>
              }
            />
            <Route
              path="/careers/:jobId"
              element={<JobDetails data={landingPageData.Careers} />}
            />
            <Route
              path="/about-us"
              element={
                <>
                  <AboutUsPage data={landingPageData.AboutUsPage} />
                </>
              }
            />

            <Route
              path="/backup-and-disaster-recovery"
              element={
                <>
                  <BackupRecoveryPage data={landingPageData.BackupRecoveryPage} />
                </>
              }
            />

          <Route
            path="/network-infrastructure-security"
            element={
              <>
                <NetworkInfrastructurePage data={landingPageData.NetworkInfrastructurePage} />
              </>
            }
          />

          <Route
            path="/data-center-solutions"
            element={
              <>  
                <DataCenterSolutionsPage data={landingPageData.DataCenterSolutionsPage} />
              </>
            }
          />

          <Route
            path="/virtual-machines"
            element={
              <>
                <VirtualMachinesPage data={landingPageData.VirtualMachinesPage} />
              </>
            }
          />

          <Route
            path="/kubernetes-setup"
            element={
              <>
                <KubernetesSetupPage data={landingPageData.KubernetesSetupPage} />
              </>
            }
          />

          <Route
            path="/docker-web-apps"
            element={
              <>
                <DockerWebAppsPage data={landingPageData.DockerWebAppsPage} />
              </>
            }
          />

          <Route
            path="/cctv-camera-systems"
            element={
              <>  
                <CCTVPage data={landingPageData.CCTVPage} />
              </>
            }
          />

          <Route
            path="/biometrics-solutions"
            element={
              <>  
                <BiometricsPage data={landingPageData.BiometricsPage} />
              </>
            }
          />

          <Route
            path="/end-user-devices"
            element={
              <>  
                <EndUserDevicesPage data={landingPageData.EndUserDevicesPage} />
              </>
            }
          />

          <Route
            path="/erp-solutions"
            element={
              <>  
                <ERPSolutionsPage data={landingPageData.ERPSolutionsPage} />
              </>
            }
          />
          <Route
            path="/crm-solutions" 
            element={
              <>    
                <CRMSolutionsPage data={landingPageData.CRMSolutionsPage} />
              </>
            }
          />

          <Route
            path="/mobile-applications"
            element={
              <>  
                <MobileApplicationsPage data={landingPageData.MobileApplicationsPage} />
              </>
            }
          />

          <Route
            path="/web-portals"
            element={
              <>  
                <WebPortalsPage data={landingPageData.WebPortalsPage} />
              </>
            }
          />

          <Route
            path="/integrations"
            element={
              <>    
                <IntegrationsPage data={landingPageData.IntegrationsPage} />
              </>
            }
          />

          <Route
            path="/edms-solutions"
            element={
              <>  
                <EDMSPage data={landingPageData.EDMSPage} />
              </>
            }
          />

          <Route
            path="/ussd-and-sms"
            element={
              <>  
                <USSDAndSmsPage data={landingPageData.USSDAndSmsPage} />
              </>
            }
          />

          <Route 
            path="/analytics-and-reporting"
            element={
              <>  
                <AnalyticsAndReportingPage data={landingPageData.AnalyticsAndReportingPage} />
              </>
            }
          />

          <Route  
            path="/cloud-network-design"
            element={
              <>  
                <CloudNetworkDesignPage data={landingPageData.CloudNetworkDesignPage} />
              </>
            }
          />

          <Route  
            path="/cloud-infrastructure-audit"
            element={
              <>  
                <CloudInfrastructureAuditPage data={landingPageData.CloudInfrastructureAuditPage} />
              </>
            }
          />

          <Route  
            path="/cloud-optimization"
            element={
              <>  
                <CloudOptimizationPage data={landingPageData.CloudOptimizationPage} />
              </>
            }
          />

          <Route  
            path="/cloud-deployments"
            element={
              <>  
                <CloudDeploymentsPage data={landingPageData.CloudDeploymentsPage} />
              </>  
            }
          />

          <Route  
            path="/unified-communications"
            element={
              <>  
                <UnifiedCommunicationsPage data={landingPageData.UnifiedCommunicationsPage} />
              </>  
            }
          />

          <Route  
            path="/mobility"
            element={
              <>  
                <MobilityPage data={landingPageData.MobilityPage} />
              </>  
            }
          />

          <Route  
            path="/managed-it"  
            element={
              <>  
                <ManagedItPage data={landingPageData.ManagedItPage} />
              </>  
            }
          /> 

          </Routes>
        
        <Contact />
        <Footer />
      </main>
    </Router>
  );
};

export default App;
